module.exports = __webpack_public_path__ + "static/media/200X200.82235aec.png";